function observeHiddenElements() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        console.log(entry);
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('hidden-animation-cards')) {
            entry.target.classList.add('show-cards');
          }
          if (entry.target.classList.contains('hidden-animation-to-top')) {
            entry.target.classList.add('show-cards-to-top');
          }
          if (entry.target.classList.contains('hidden-animation-heading')) {
            entry.target.classList.add('show-animation-heading');
          }
          if (entry.target.classList.contains('hidden-animation-button')) {
            entry.target.classList.add('show-animation-button');
          }
          if (entry.target.classList.contains('hidden-animation-sub')) {
            entry.target.classList.add('show-animation-sub');
          }
          if (entry.target.classList.contains('hidden-animation-testimonials')) {
            entry.target.classList.add('show-animation-testimonials');
          }
          if (entry.target.classList.contains('hidden-animation-overlapping-images')) {
            entry.target.classList.add('show-animation-overlapping-images');
          }
        } else {
          entry.target.classList.remove('show-animation-heading', 'show-animation-sub', 'show-animation-button');
        }
      });
    });
    
    const hiddenElements = document.querySelectorAll('.hidden-animation-to-top, .hidden-animation-overlapping-images, .animation-slideshow-button, .hidden-animation-cards, .hidden-animation-heading, .hidden-animation-testimonials, .hidden-animation-sub, .hidden-animation-button');
    hiddenElements.forEach((el) => observer.observe(el));
  }

  window.addEventListener('DOMContentLoaded', (event) => {
    window.dispatchEvent(new Event('resize'));
    observeHiddenElements()
  });
  
  document.addEventListener("shopify:section:load", function(event) {
    window.dispatchEvent(new Event('resize'));
    observeHiddenElements()
  });